import React, { memo, useContext, useEffect, useState } from "react";
import { openLayerFn } from "../Layout";
import { AppContext, SET_APP_SETINFO } from "../../components/AppProvider";
import { PostApi1914 } from "../../modules/network/padoPost";

export const ItemOnOffLayer = memo(({ isGray, id, name, isOn, op }) => {
  const { userinfo, cfg, phonecfg, dispatch } = useContext(AppContext);
  const [btnOn, setBtnOn] = useState(isOn === true ? true : false);

  const toggleOnOff = () => {
    setBtnOn(!btnOn);
    // request1914(userinfo, cfg, phonecfg, dispatch, 'isOn', btnOn === true ? 'Y' : 'N', id);
    // TODO: API호출
    // setBtnOn 이후 btnOn의 state가 즉시 업데이트 되지 않기에
    // 현재 값 기준으로 비교
    dispatch({
      type: SET_APP_SETINFO,
      key: id,
      data: btnOn === true ? "N" : "Y",
    });

    request1914(userinfo, cfg, phonecfg, id, btnOn === true ? "N" : "Y", "");
  };

  const request1914 = (userinfo, cfg, phonecfg, setColumn, setValue, hpKey) => {
    PostApi1914(userinfo, cfg, phonecfg, setColumn, setValue, hpKey)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <div className={isGray === true ? "gray-r-box" : "rd-box"}>
      {name}
      <span
        className={btnOn === true ? "onoff-btn on" : "onoff-btn off"}
        id={id}
        op={op}
        onClick={() => toggleOnOff()}>
        <em>
          <u>ON</u>
          <s></s>
          <u>OFF</u>
        </em>
      </span>
    </div>
  );
});

export const ItemOnOffLayerH = memo(
  ({ isGray, id, name, address2, isOn, op, ptntNo, setHpKey, setHpName }) => {
    const { userinfo, cfg, phonecfg, dispatch } = useContext(AppContext);
    const [btnOn, setBtnOn] = useState(isOn === true ? true : false);

    const addPtntNo = () => {
      // request1914(userinfo, cfg, phonecfg, dispatch, 'hpKey', 'Y', hpKey);
      setHpKey(id);
      setHpName(name);
      // 환자번호 등록 팝업
      $("#ptntNo").val("");
      openLayerFn($("#inputPopup"));
    };

    const checkName = param => {
      let rtnValue = param;

      // 병원명이 8글자 이상인경우 3글자+...표시
      if (rtnValue.length >= 8) {
        rtnValue = rtnValue.substring(0, 7) + "...";
      }

      return rtnValue;
    };

    const toggleOnOff = () => {
      setBtnOn(!btnOn);
      // request1914(userinfo, cfg, phonecfg, dispatch, 'isOn', btnOn === true ? 'Y' : 'N', id);
      // TODO: API호출
      // setBtnOn 이후 btnOn의 state가 즉시 업데이트 되지 않기에
      // 현재 값 기준으로 비교
      dispatch({
        type: SET_APP_SETINFO,
        key: id,
        data: btnOn === true ? "N" : "Y",
      });

      request1914(userinfo, cfg, phonecfg, id, btnOn === true ? "N" : "Y", "");
    };

    const request1914 = (
      userinfo,
      cfg,
      phonecfg,
      setColumn,
      setValue,
      hpKey
    ) => {
      PostApi1914(userinfo, cfg, phonecfg, setColumn, setValue, hpKey)
        .then(res => {
          if (res.resultMsg === "SUCCESS") {
          } else {
            console.log("LOGOUT!!!");
          }
        })
        .catch(err => {
          console.log(err);
        });
    };

    return (
      <div
        className={isGray === true ? "gray-r-box" : "rd-box"}
        style={{ fontWeight: "400" }}>
        <div onClick={() => addPtntNo()}>
          {checkName(name) + "(" + address2 + ")"}
        </div>
        {/* <span className={isOn === true ? "onoff-btn on" : "onoff-btn off"  } id = {id} op = {op} ><em><u>ON</u><s></s><u>OFF</u></em></span> */}
        <span
          className={btnOn ? "onoff-btn on" : "onoff-btn off"}
          id={id}
          op={op}
          onClick={() => toggleOnOff()}>
          <em>
            <u>ON</u>
            <s></s>
            <u>OFF</u>
          </em>
        </span>
      </div>
    );
  }
);
